module.exports = __webpack_public_path__ + "static/media/samples.cecfd74e.svg";